"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var data;
        (function (data) {
            var viewEntry;
            (function (viewEntry) {
                class InitArgs {
                    constructor() {
                        this.entryId = appn.emptyString;
                        this.exportSingleEntry = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                }
                viewEntry.init = init;
                function addEvents() {
                    $(document).on('hidden.bs.modal', function () {
                        if (appn.iframe.getHost().reloadFlag)
                            appn.location.reloadCurrentPage();
                    });
                    $('#btnprint').on('click', function (e) {
                        e.preventDefault();
                        window.print();
                    });
                    $('#btnexport').on('click', function (e) {
                        e.preventDefault();
                        const params = appn.location.buildQueryString([{ name: 'id', value: _initArgs.entryId }]);
                        let updateNotificationTotal = appn.notifications.updateNotificationTotal;
                        if (appn.utils.hasValue(window.opener))
                            updateNotificationTotal = window.opener.appn.notifications.updateNotificationTotal;
                        appn.ajax.post({
                            url: _initArgs.exportSingleEntry + params,
                            data: $('#exportForm').serialize(),
                            done: function () {
                                if (updateNotificationTotal) {
                                    if (appn.utils.hasValue(window.opener))
                                        updateNotificationTotal.call(window.opener);
                                    else
                                        updateNotificationTotal.call(window);
                                }
                                appn.ui.showExportConfirmation('Form Entry');
                            },
                            fail: function () {
                                appn.toast.notify(appn.toast.Type.error, T('Form Entry failed.'));
                            }
                        });
                    });
                    $('.btn-removeFieldNames').on('click', function (e) {
                        e.preventDefault();
                        $('.text-muted').remove();
                        $(this).remove();
                    });
                }
            })(viewEntry = data.viewEntry || (data.viewEntry = {}));
        })(data = views.data || (views.data = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
